import { Injectable } from '@angular/core';
import { CurrencyFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find-many-query.dto';
import { CurrencyPageInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisCurrencyService extends BaseService {
  protected baseUrl = '/basis/catalog/currency';

  public findWithPagination(queryParams: CurrencyFindManyQueryInterface): Observable<CurrencyPageInterface> {
    return this.http.get<CurrencyPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
